// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"24":"918673ea","96":"a6627c2d","246":"a6627c2d","431":"a6627c2d","462":"a6627c2d","580":"a6627c2d","640":"a6627c2d","746":"a6627c2d"}[chunkId] + ".chunk.css";
};